<template lang="pug">
  validation-observer(ref="form")
    form(@submit.prevent="onSubmit" :class="b()")
      validation-provider(name="correo" rules="required|email" v-slot="{ errors }")
        v-text-field(
          v-model="data.email"
          :disabled="disabled"
          :error-messages="errors"
          type="email"
          name="correo"
          placeholder="Ingresa tu correo electrónico, Ejemplo: juan@gmail.com"
        )
</template>

<script>
  import formMixin from '@/mixins/form-mixin';

  const DEFAULT_VALUES = {
    email: null,
  };

  export default {
    name: 'customer-form-1',

    mixins: [
      formMixin(),
    ],

    data() {
      return {
        data: {
          ...DEFAULT_VALUES,
        },
      };
    },
  };
</script>

<style lang="sass" scoped>
  .customer-form
    &__error
      color: red
      font-size: 0.9rem

    .label
      font-size: 0.85rem
      margin: 0
</style>